/**
 * Färg härledd ur ett namn, så att samma person alltid får samma kulör
 * i listor och på kartan. Delas av Avatar och kartmarkörerna.
 */
// Kulorer som halls isar mot asfaltsvart. Limen ar medvetet utelamnad —
// den ar appens handlingsfarg och ska inte betyda "en viss person".
const COLORS = ['#4dd2ff', '#ff6bd6', '#ffb340', '#a78bfa', '#5eead4', '#ff8a6b'];

export default function avatarColor(name = '') {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) % 100000;
  }
  return COLORS[hash % COLORS.length];
}

export const initialOf = (name = '') => (name.trim()[0] || '?').toUpperCase();
